import React, { useState } from "react";
import { Modal, Button, Typography, Select, Input } from "antd";

const { Option } = Select;
const { Text } = Typography;
const { TextArea } = Input;

const CambiarEstadoTrasladoDialog = ({
  open,
  onClose,
  onConfirm,
  estadoActual,
  excludeEstados = [], // Estados a excluir (ej: ["Fallido"] para TAI)
}) => {
  const [nuevoEstado, setNuevoEstado] = useState(null);
  const [motivo, setMotivo] = useState("");
  const [error, setError] = useState("");

  // Determinar opciones disponibles según estado actual
  const opcionesEstadoBase = {
    Finalizado: ["Cancelado", "Fallido"],
    Cancelado: ["Finalizado", "Fallido"],
    Fallido: ["Finalizado", "Cancelado"],
    FallidoXvalidar: ["Finalizado", "Cancelado", "Fallido"],
    FinalizadoXvalidar: ["Finalizado", "Cancelado", "Fallido"],
  };

  // Filtrar estados excluidos
  const opcionesEstado = Object.fromEntries(
    Object.entries(opcionesEstadoBase).map(([key, values]) => [
      key,
      values.filter((estado) => !excludeEstados.includes(estado)),
    ])
  );

  const handleConfirm = () => {
    if (!nuevoEstado) {
      setError("Debe seleccionar un nuevo estado");
      return;
    }
    
    if (!motivo.trim()) {
      setError("Debe ingresar un motivo para el cambio");
      return;
    }

    if (/^\d+$/.test(motivo)) {
      setError("El motivo debe ser una descripción textual, no solo números");
      return;
    }

    onConfirm(nuevoEstado, motivo);
    setNuevoEstado(null);
    setMotivo("");
    setError("");
  };

  const handleCancel = () => {
    setNuevoEstado(null);
    setMotivo("");
    setError("");
    onClose();
  };

  return (
    <Modal
      title={`Cambiar Estado (Actual: ${estadoActual})`}
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleConfirm}
          disabled={!nuevoEstado || !motivo.trim()}
        >
          Cambiar Estado
        </Button>,
      ]}
    >
      <div style={{ padding: "20px 0" }}>
        <Text strong>Seleccione el nuevo estado:</Text>
        <Select
          style={{ width: "100%", margin: "10px 0" }}
          placeholder="Seleccione un estado"
          value={nuevoEstado}
          onChange={(value) => setNuevoEstado(value)}
        >
          {opcionesEstado[estadoActual]?.map((estado) => (
            <Option key={estado} value={estado}>
              {estado}
            </Option>
          ))}
        </Select>

        <div style={{ marginTop: 20 }}>
          <Text strong>Motivo del cambio:</Text>
          <TextArea
            rows={4}
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder="Explique el motivo del cambio de estado..."
            style={{ marginTop: 8 }}
          />
          {error && (
            <Text type="danger" style={{ display: "block", marginTop: 8 }}>
              {error}
            </Text>
          )}
        </div>

        <Text type="warning" style={{ marginTop: 15, display: "block" }}>
          Esta acción actualizará las estadísticas de la autorización asociada
        </Text>
      </div>
    </Modal>
  );
};

export default CambiarEstadoTrasladoDialog;